import {
  ApiFilterOperation,
  DatedEvidence,
  TableCells,
  TableFilterCells,
} from '@eas/common-web';
import { ImportRequest } from '@models';
import { useDataSources } from '@modules/data-source/data-source-api';
import { useIntl } from 'react-intl';
import { useNonStandardStates, useProcessStates } from './import-request-api';

export const useColumns = () => {
  const intl = useIntl();
  const { datedColumns } = DatedEvidence.useDatedColumns<ImportRequest>();

  return [
    {
      datakey: 'source',
      sortkey: 'source.name',
      filterkey: 'source.id',
      name: intl.formatMessage({
        id: 'TAPIS_IMPORT_REQUEST__TABLE__COLUMN__SOURCE',
        defaultMessage: 'Zdroj informací',
      }),
      width: 200,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.dictionaryColumnMapper,
      FilterComponent:
        TableFilterCells.useFilterAutocompleteCellFactory(useDataSources),
      filterOperation: ApiFilterOperation.EQ,
      sortable: true,
      filterable: true,
    },

    {
      datakey: 'processState',
      sortkey: 'processState.name',
      filterkey: 'processState.id',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__PROCESS_STATE',
        defaultMessage: 'Stav procesu',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      valueMapper: TableCells.useSelectCellFactory(useProcessStates),
      FilterComponent:
        TableFilterCells.useFilterSelectCellFactory(useProcessStates),
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'importedCount',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__IMPORTED_COUNT',
        defaultMessage: 'Počet importovaných záznamů',
      }),
      width: 150,
      CellComponent: TableCells.NumberCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'incremental',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__INCREMENTAL',
        defaultMessage: 'Inkrementální',
      }),
      width: 120,
      CellComponent: TableCells.BooleanCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'started',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__STARTED',
        defaultMessage: 'Spuštěno',
      }),
      width: 120,
      CellComponent: TableCells.DateTimeCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'finished',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__FINISHED',
        defaultMessage: 'Ukončeno',
      }),
      width: 120,
      CellComponent: TableCells.DateTimeCell,
      sortable: true,
      filterable: true,
    },
    {
      datakey: 'nonStandardStates',
      filterkey: 'nonStandardStates',
      name: intl.formatMessage({
        id: 'TAPIS__IMPORT_REQUEST__COLUMN__NON_STANDARD_STATES',
        defaultMessage: 'Nestandartní stavy',
      }),
      width: 150,
      CellComponent: TableCells.TextCell,
      FilterComponent:
        TableFilterCells.useFilterAutocompleteCellFactory(useNonStandardStates),
      filterOperation: ApiFilterOperation.EQ,
      filterable: true,
      hidden: true,
    },

    ...datedColumns,
  ];
};
